export default {"src":"/_next/static/media/sports3.151a57bd.svg","height":154,"width":72,"blurWidth":0,"blurHeight":0};